import UserMutations from "./user/user.mutation";
import UserQueries from "./user/user.query";

const UserServices = {
  ...UserQueries,
  ...UserMutations,
};

export default UserServices;
